import { FormControl, FormHelperText, InputLabel, MenuItem, Select, colors,Checkbox, FormControlLabel, FormGroup  } from "@material-ui/core";
import React, { Component } from "react";
import Modal from "react-modal";
import { connect } from "react-redux";
import { AiOutlineCloseCircle } from "react-icons/ai";

import { adminPanelBaseStyles } from "../../theme/style";
import { convertToRoleStrings, fromRoleNumToString, getUserRoles, parseJwt } from "../../utils/CFuncs";
import { AdminAccessRole, roles } from "../../utils/Objects";
import Cookies from "js-cookie";
import { setError } from "../../redux/actions/MessageAction";
import Alerts from "../common/Alerts";

class EditUserModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {
        firstName: "",
        lastName: "",
        username: "",
        email:"",
        roleID:"",
        roles:[],
        ...this.props.currentUser
    },
    statusOpen: false,
    isChecked: this.hasAdminRole(),

    };
  }


  createCustomUser(user){
    let custommUser = Object.assign({}, user)
    custommUser.password = '9sr8tl8rsl8rs'
    custommUser.username = user.email
    custommUser.first_name = user.firstName
    custommUser.last_name = user.lastName
    custommUser.role = user.roleID
    
    delete custommUser.roleID
    delete custommUser.firstName
    delete custommUser.lastName
    return custommUser
  }
  
  updateUser = () => {
    try {
      this.checkValidity()
      const customUser = this.createCustomUser(this.state.user)
      // can be add or delete user
      const roleAction  = this.state.isChecked ? AdminAccessRole.Grant: AdminAccessRole.Remove
      this.props.handleClick(customUser,roleAction);
      console.log('checkValidity updateUser VALID: ');
      
    } catch (error) {
      console.log('checkValidity updateUser error: ');
      console.log(error.message)
      this.props.setError(error.message)
    }
  }
  onChange = ({name,value}) => {    
    let newUser = { ...this.state.user, [name]: value };

    this.setState({user:newUser,isOpen:false })
    this.props.setError('')
  }
  closeModal = () => {    
    this.props.closeModal()
    this.props.setError('')
  }
  handleStatusClose = () => {
    this.setState({ statusOpen: false });
  };

  handleStatusOpen = () => {
    if(!this.hasPermissionForEditRole()){
      this.props.setError('You dont have permission to change this role')
      return
    }
    this.setState({ statusOpen: true });
  };

  checkValidity = () => {
    const { firstName ,lastName} = this.state.user
    if(firstName ==="" || lastName === ""){
      throw new Error("fields cannot be empty ")
    }
    if(firstName.match( /\d/)) throw new Error("first firstName cannot contain numbres ")
    if(lastName.match( /\d/)) throw new Error("last name cannot contain numbres ")


    return true 

    }
    hasPermissionForEditRole=()=>{
      console.log('hasPermissionForEditRole')
      const token = Cookies.get("auth")
      const user = parseJwt(token)
      const isLoggedUser = user.uid == this.state.user.id
      const isAdmin = user.roles === roles.Administrator
      const isUserAdmin =  user.roleType === roles.Administrator
      console.log(user.roleType )
      return (isAdmin || isUserAdmin) && !isLoggedUser
    }

    hasAdminRole = ()=>{
      
      if(!this.props.currentUser?.roles) return false
      
      console.log(this.props.currentUser)
      const myRolesNums  = this.props.currentUser?.roles
      const myRoles = convertToRoleStrings(myRolesNums)

      return myRoles.includes(roles.Administrator)
    }
 
    handleRoleToAdd = (e) =>{
      this.setState({isChecked: e.target.checked});
      
    }

  render() {
    console.log('render')
    console.log(this.state)
    const {user}  = this.state
    // / cehck that and put in thet other modal of the paitent
    return (
      <Modal
        ariaHideApp={false}
        isOpen={this.props.showModal}
        style={{
          content: { ...styles.centerModal },
        }}
        // onAfterOpen={afterOpenModal}
        onRequestClose={this.closeModal}
        // style={customStyles}
        contentLabel="Diagnosis Modal"
      >
        <div style={styles.container}>
          <AiOutlineCloseCircle
            style={styles.closeButton}
            onClick={() => this.props.closeModal()}
          />
          <div style={styles.title}>{this.props.title}</div>
          <div style={styles.insideContainer}>
            <dl>
              <dt>First Name</dt>
              <dd>
                <input
                  name="firstName"
                  value={user.firstName}
                  onChange={e=>this.onChange(e.target)
                  }
                  />
              </dd>

              <dt>lastName</dt>
              <dd>
                <input
                name="lastName"
                  value={user.lastName}
                  onChange={e=>this.onChange(e.target)}
                  
                />
              </dd>

              <dt>email</dt>
              <dd>
                <input
                  name="email"
                  value={user.email}
                  disabled={true}
       />
              </dd>

              <dt>username</dt>
              <dd>
                <input
                  name="username"
                  value={user.email}
                  disabled={true}
                 
                  />
              </dd>

  
         </dl>
         <FormControl style={adminPanelBaseStyles.select}>
              <InputLabel>Role Status</InputLabel>
              <Select
                open={this.state.statusOpen}
                onClose={this.handleStatusClose}
                onOpen={this.handleStatusOpen}
                value={user.roleID}
                onChange={(e) =>{

                  console.log('on change EDTI MODAL');
                  console.log(e.target);
                  console.log(e.target.value);
                  this.onChange({ name: "roleID", value: e.target.value })
                  
                }
                }
                inputProps={{ name: "user Status" }}
              >
                <FormHelperText>
                  <em>Role</em>
                </FormHelperText>
                <MenuItem value={1}>User</MenuItem>
                <MenuItem value={0}>Administrator</MenuItem>
              </Select>
            </FormControl>



{/* //////// the secodn entitiy role grant  */}
  <FormGroup>
    
    <div>entity role :</div>
    <FormControlLabel control={<Checkbox checked={this.state.isChecked} onChange={this.handleRoleToAdd} />} label={roles.Administrator} />
  </FormGroup>

            <div
              onClick={() => {
                this.updateUser()
                
              }}
              style={styles.button}
            >
              Edit User Details
            </div>
          </div>
          <Alerts />
        </div>
      </Modal>
    );
  }
}

const styles = {
  centerModal: {
    width: 600,
    height: 600,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  container: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    // border: '1px solid'
  },
  insideContainer: {
    display: "flex",
    flexDirection: "column",
    // border: '1px solid'
  },
  title: {
    position: "relative",
    top: -50,
    textAlign: "center",
    fontWeight: "bold",
    fontSize: 40,
  },
  buttonClose: {
    position: "absolute",
    top: 1,
    right: 1,
  },
  button: {
    cursor: "pointer",
    backgroundColor: "#4CAF50",
    border: "none",
    color: "white",
    padding: 7,
    textAlign: "center",
    textDecoration: "none",
    display: "inline-block",
    fontSize: 16,
    userSelect: "none",
  },
  error: {
    color: "red",
  },
  // buttonDisabled: {
  //   cursor: 'pointer',
  //   backgroundColor: '#9f9f9f',
  //   border: 'none',
  //   color: 'white',
  //   padding: 7,
  //   textAlign: 'center',
  //   textDecoration: 'none',
  //   display: 'inline-block',
  //   fontSize: 16,
  //   userSelect: 'none'
  // },
  buttonScroll: {
    cursor: "pointer",
    border: "none",
    padding: 7,
    textAlign: "center",
    textDecoration: "none",
    fontWeight: "bold",
    display: "inline-block",
    fontSize: 16,
    userSelect: "none",
  },
  buttonScrollNoMore: {
    cursor: "pointer",
    border: "none",
    color: colors.purpleGrey,
    padding: 7,
    textAlign: "center",
    textDecoration: "none",
    display: "inline-block",
    fontSize: 16,
    userSelect: "none",
  },
  closeButton: {
    position: "absolute",
    top: "10px",
    right: "10px",
    width: "30px",
    height: "30px",
    cursor: "pointer",
  },
};
const mapStateToProps = (state, ownProps) => {
  return {
    error: state.message.error,
  };
};

const mapDispatchToProps = {
  setError,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditUserModal);
